const baseUrl = process.env.VUE_APP_apiBase

export default {
  getCheckCode: `${baseUrl}/v1/user/getCheckCode`,
  login: `${baseUrl}/v1/user/login`,
  getSts: `${baseUrl}/v1/upload/sts`,
  uploadVideo: `${baseUrl}/v1/userVideo/userLongVideo/create`,
  videoHistory: `${baseUrl}/v1/userVideo/userLongVideo/history`
}
